var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apploader"},[_c('video',{staticClass:"apploader__video",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true},on:{"canplay":function($event){return _vm.ResolveElement($event)}}},[_c('source',{attrs:{"src":require("@/assets/Images/Static/AppLoader.webm"),"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }